// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-item{font-family:\"Inter\";font-size:16px;line-height:20px;font-family:\"Montserrat\",sans-serif;display:block;padding:.25rem 1rem;margin-top:.25rem;margin-bottom:.25rem;font-weight:500;text-decoration:none;color:#283651}.dropdown-item:hover{background-color:#eee}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
